import React from 'react';
import ReactGA from 'react-ga4';
import MediaQuery from 'react-responsive'
import './styles/Header.scss'


const Header= ({sectionCurrently, positionCurrently, setSectionCurrently, setPositionCurrently, Section, Position}) => {
  
  const scrollBottom = () =>{
    return sectionCurrently === Section.Section1 && positionCurrently === Position.BOTTOM 
  }

  const redirect = (section) => {
    const elementoDestino = document.getElementById(section);
    elementoDestino.scrollIntoView({ behavior: 'smooth' });
  }

  const handleRedirect = () => {
    const url = 'http://app.conkarta.com/application';
    window.open(url, '_blank', 'noopener,noreferrer');

    try {
      ReactGA.event({
        category: 'Botón',
        action: 'Clic en botón',
        label: 'Botón Header',
      });
    } catch (error) {
      console.error('Error al enviar el evento a GA:', error);
    }
  };

  const logoClass = "logo-img";
  const linkClass = "link-text";
  const buttonClass = "join-button";
  return (
    <>
      <header>
        <div className="header-section disposition-row justify-between align-center">
          <img src = "assets/Header/Logo-Karta.png" className = { `${logoClass} ${scrollBottom() ? "" : ""}`}  alt = "Logo" onClick={() => redirect("section-1")}></img>
          <MediaQuery minWidth={900}>
            <div className = "links-section disposition-row justify-around align-center">
                <p className = { `${linkClass} ${scrollBottom() ? "" : ""}`} onClick={() => redirect("section-3")}>Lowest fees</p>
                <p className = { `${linkClass} ${scrollBottom() ? "" : ""}`} onClick={() => redirect("section-5")}>Credit limit</p>
                <p className = { `${linkClass} ${scrollBottom() ? "" : ""}`} onClick={() => redirect("section-7")}>Card benefits</p>
            </div>
          </MediaQuery>
          <div className = "disposition-row justify-around align-center">
              <button className = { `${buttonClass} ${scrollBottom() ? "" : ""}`} onClick={handleRedirect}>Join Waitlist</button>
          </div>
        </div>
      </header>
    </>
  ); 
};

export default Header;
